module.exports = __webpack_public_path__ + "static/media/h5_game_header_logo.346d94aa.png";